exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider {\n  position: initial;\n  margin: 0px;\n  padding: 12px 25px;\n  background-color: #fdfdfd;\n  border: 2px solid #f1f1f1; }\n  .slider .left-arrow {\n    height: 100%;\n    background-color: #ffffff00;\n    cursor: pointer;\n    position: absolute;\n    left: 6px;\n    font-size: 2rem;\n    top: 0; }\n    .slider .left-arrow i {\n      color: #fb931a; }\n  .slider .right-arrow {\n    height: 100%;\n    background-color: #ffffff00;\n    cursor: pointer;\n    position: absolute;\n    right: 6px;\n    font-size: 2rem;\n    top: 0; }\n    .slider .right-arrow i {\n      color: #fb931a; }\n  .slider .flight .info p {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden; }\n  .slider::before {\n    display: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/shared/item-slider/item-slider.component.scss
// module id = ../../../../../src/app/shared/item-slider/item-slider.component.scss
// module chunks = main